import { StorageOfUniqueServices } from '@qality/common-service';

export default {
  async init() {
    StorageOfUniqueServices.get('HostNameService').init();
    StorageOfUniqueServices.get('LicenseService').init();
    StorageOfUniqueServices.get('WindowOriginService').init();
  },
};
